module.exports = __webpack_public_path__ + "static/media/our_style.8f567f03.svg";